import React from "react";
import { Fade } from "react-awesome-reveal";
import { useGalleryBannerContext } from "../../context/GalleryContext";

const GalleryBanner = () => {
  const { galleryBannerData } = useGalleryBannerContext();
  return (
    <>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-3819d2cc elementor-section-stretched elementor-section-height-min-height elementor-section-boxed elementor-section-height-default elementor-section-items-middle"
        data-id="3819d2cc"
        data-element_type="section"
        data-settings='{"stretch_section":"section-stretched","background_background":"classNameic","hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
        style={{
          backgroundImage: galleryBannerData[0]?.attributes?.Image?.data
            ?.attributes?.url
            ? `url(${process.env.REACT_APP_strapiUrl}${galleryBannerData[0]?.attributes?.Image?.data?.attributes?.url})`
            : "https://dashboard.scieverinc.com.np/uploads/logo_white3_747fc8e5de.png",
        }}
      >
        {/* <div className="elementor-background-overlay"></div> */}
        <div className="elementor-container elementor-column-gap-default">
          <div className="custom-gradient" style={{ height: "700px" }}></div>
          <div className="elementor-row" style={{ width: "100%", zIndex: 1 }}>
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-712ebef7"
              data-id="712ebef7"
              data-element_type="column"
              data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
            >
              <div className="elementor-column-wrap elementor-element-populated">
                <div className="elementor-widget-wrap">
                  <Fade cascade damping={0.2} direction="up" triggerOnce={true}>
                    <div
                      className="elementor-element elementor-element-65b4e6de elementor-invisible elementor-widget elementor-widget-heading"
                      data-id="65b4e6de"
                      data-element_type="widget"
                      data-settings='{"_animation":"fadeInUp","hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h1 className="elementor-heading-title elementor-size-default">
                          {galleryBannerData[0]?.attributes?.Title}
                        </h1>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-55adc588 elementor-invisible elementor-widget elementor-widget-heading"
                      data-id="55adc588"
                      data-element_type="widget"
                      data-settings='{"_animation":"fadeInUp","_animation_delay":400,"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h5 className="elementor-heading-title elementor-size-default">
                          {galleryBannerData[0]?.attributes?.Description}
                        </h5>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GalleryBanner;
